<div class="container-fluid" style="margin-top: 5% !important;" *ngIf="clientData.cliente.existeClienteActualizado !== 'S'">
  <div class="card mt-1">
    <span class="text-center" style="color: #de2460">
      <i class="bi bi-circle-fill mr-3 " style="font-size: 8px"></i>
      <span class="mt-1" *ngIf="clientData.cliente.existeClienteConCodigoBantrab === 'N'">
        <span *ngIf="clienteserviceParam.flowType === 'DEBTOR'">
          Los datos del cliente deben ser registrados
        </span>
        <span *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
          Los datos del codeudor deben ser registrados
        </span>
      </span>
      <span class="mt-1" *ngIf="clientData.cliente.existeClienteActualizado !== 'S'
        && clientData.cliente.existeClienteConCodigoBantrab !== 'N'">
        <span *ngIf="clienteserviceParam.flowType === 'DEBTOR'">
          Los datos del cliente se encuentran desactualizados
        </span>
        <span *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
          Los datos del codeudor se encuentran desactualizados
        </span>
      </span>
    </span>
  </div>
</div>
<div class="container-fluid">
    <div class="row header-consolidacion">
        <div class="col-md-9">
            <div class="row">
                <div class="col-2">
                    <ngx-avatar size="40" src="assets/images/general/avatar.png"></ngx-avatar>
                </div>
                <div class="col-10">
                  <h4>{{clientData.cliente.nombreCompleto|accentMark: false }}</h4>
                  <p>Código Cliente: {{clientData.cliente.codigoClienteBantrab}}</p>
                </div>
            </div>
        </div>
        <div class="col-md-3">

        </div>
    </div>
    <div class="title">
        <div class="row" *ngIf="(ProductoSeleccionado.descTipoActivo == 'Prestamos' || ProductoSeleccionado.descTipoActivo == 'Factoraje') && ProductoSeleccionado.nomEntidad == 'BANCO DE LOS TRABAJADORES'">
            <div class="col-md-3">
                <p>Crédito No.</p>
                <h3>{{ProductoSeleccionado.NO_CREDITO}}</h3>
            </div>
            <div class="col-md-6">
                <h2>{{ProductoSeleccionado.CodEntidad}}</h2>
            </div>
            <div class="col-md-3">

            </div>
        </div>
        <div class="row" *ngIf="ProductoSeleccionado.descTipoActivo == 'Tarjeta de Credito' && ProductoSeleccionado.CodEntidad == 'BANCO DE LOS TRABAJADORES'">
            <div class="col-md-3">
                <p>Tarjeta No.</p>
                <h3>**** **** **** {{ProductoSeleccionado.NO_TARJETA.substring(ProductoSeleccionado.NO_TARJETA.length-4)}}</h3>
            </div>
            <div class="col-md-6">
                <h2>{{ProductoSeleccionado.CodEntidad}}</h2>
            </div>
            <div class="col-md-3">

            </div>
        </div>
        <div class="row"  *ngIf="ProductoSeleccionado.nomEntidad !== 'BANCO DE LOS TRABAJADORES'">
            <div class="col-md-3">

            </div>
            <div class="col-md-6">
                <h2>{{ProductoSeleccionado.CodEntidad}}</h2>
            </div>
            <div class="col-md-3">

            </div>
        </div>
    </div>
    <div class="producto" *ngIf="ProductoSeleccionado.descTipoActivo == 'Prestamos' || ProductoSeleccionado.descTipoActivo == 'Factoraje'">
        <div class="row">
            <div class="col-md-6">
                <h3>{{ProductoSeleccionado.fecconce}}</h3>
                <h2>Fecha de Apertura</h2>
            </div>
            <div class="col-md-6">
                <h3>{{ProductoSeleccionado.fecvence}}</h3>
                <h2>Fecha de Vencimiento</h2>
            </div>
        </div>
    </div>
    <div class="producto" *ngIf="ProductoSeleccionado.descTipoActivo == 'Tarjeta de Credito'">
        <div class="row">
            <div class="col-md-6">
                <h3>{{ProductoSeleccionado.fecconce}}</h3>
                <h2>Fecha de Consesión</h2>
            </div>
            <div class="col-md-6">
            </div>
        </div>
    </div>
    <div class="producto" >
        <div class="row">
            <div class="col-md-6">
                <h3> {{ProductoSeleccionado.capitalOrig | currency:"Q "}}</h3>
                <h2 *ngIf="ProductoSeleccionado.descTipoActivo == 'Prestamos' || ProductoSeleccionado.descTipoActivo == 'Factoraje'">Capital Original</h2>
                <h2 *ngIf="ProductoSeleccionado.descTipoActivo == 'Tarjeta de Credito'">Limite de Crédito</h2>
            </div>
            <div class="col-md-6">
                <h3>{{ProductoSeleccionado.saldo |currency:"Q "}}</h3>
                <h2>Saldo</h2>
            </div>
        </div>
    </div>
    <div class="producto" *ngIf="(ProductoSeleccionado.descTipoActivo == 'Prestamos' || ProductoSeleccionado.descTipoActivo == 'Factoraje') && ProductoSeleccionado.nomEntidad == 'BANCO DE LOS TRABAJADORES'">
        <div class="row">
            <div class="col-md-6">
                <h3> {{ProductoSeleccionado.SALDO_VENCIDO | currency:"Q "}}</h3>
                <h2 *ngIf="ProductoSeleccionado.descTipoActivo == 'Prestamos' || ProductoSeleccionado.descTipoActivo == 'Factoraje'">Saldo Vencido</h2>
            </div>
            <div class="col-md-6">
                <h3>{{ProductoSeleccionado.DESCUENTO_CODEUDOR}}</h3>
                <h2>Descuento Codeudor</h2>
            </div>
        </div>
    </div>
    <div class="producto" >
        <div class="row">
            <div class="col-md-6">
                <div *ngIf="(ProductoSeleccionado.descTipoActivo == 'Prestamos' || ProductoSeleccionado.descTipoActivo == 'Factoraje') && ProductoSeleccionado.nomEntidad == 'BANCO DE LOS TRABAJADORES'">
                    <h3> {{ProductoSeleccionado.CUOTA| currency:"Q "}}</h3>
                    <h2 >Cuota</h2>
                </div>
                <div *ngIf="ProductoSeleccionado.descTipoActivo == 'Tarjeta de Credito' && ProductoSeleccionado.nomEntidad == 'BANCO DE LOS TRABAJADORES'">
                    <h3> {{ProductoSeleccionado.PAGO_MINIMO | currency:"Q "}}</h3>
                    <h2 >Pago Minimo</h2>
                </div>
                <div *ngIf="ProductoSeleccionado.nomEntidad != 'BANCO DE LOS TRABAJADORES'">
                    <h3> {{ProductoSeleccionado.descEstado}}</h3>
                    <h2 >Estado</h2>
                </div>
            </div>
            <div class="col-md-6">
                <div *ngIf="(ProductoSeleccionado.descTipoActivo == 'Prestamos' || ProductoSeleccionado.descTipoActivo == 'Factoraje') && ProductoSeleccionado.nomEntidad == 'BANCO DE LOS TRABAJADORES'">
                    <h3>{{ProductoSeleccionado.C_POR_PAGAR}}</h3>
                    <h2 >Cuotas por Pagar</h2>
                </div>
                <div *ngIf="ProductoSeleccionado.descTipoActivo == 'Tarjeta de Credito'  && ProductoSeleccionado.nomEntidad == 'BANCO DE LOS TRABAJADORES'">
                    <h3>{{ProductoSeleccionado.DIAS_MORA}}</h3>
                    <h2 >Días de Mora</h2>
                </div>
                <div *ngIf="ProductoSeleccionado.nomEntidad != 'BANCO DE LOS TRABAJADORES'">
                    <h3>{{ProductoSeleccionado.descTipoGara}}</h3>
                    <h2>Tipo Garatia</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="producto" *ngIf="ProductoSeleccionado.descTipoActivo == 'Tarjeta de Credito'  && ProductoSeleccionado.nomEntidad == 'BANCO DE LOS TRABAJADORES'">
        <div class="row">
            <div class="col-md-6">
                <div *ngIf="ProductoSeleccionado.descTipoActivo == 'Prestamos' || ProductoSeleccionado.descTipoActivo == 'Factoraje'">
                    <h3>{{ProductoSeleccionado.ABREV_ESTADO}}</h3>
                    <h2>Estado</h2>
                </div>
                <div *ngIf="ProductoSeleccionado.descTipoActivo == 'Tarjeta de Credito'  && ProductoSeleccionado.nomEntidad == 'BANCO DE LOS TRABAJADORES'">
                    <h3>{{ProductoSeleccionado.ESTADO}}</h3>
                    <h2>Estado</h2>
                </div>
            </div>
            <div class="col-md-6">
                <div *ngIf="ProductoSeleccionado.descTipoActivo == 'Prestamos' || ProductoSeleccionado.descTipoActivo == 'Factoraje'">
                    <h3> {{ProductoSeleccionado.TIPO_CREDITO}}</h3>
                    <h2>Tipo de Credito</h2>
                </div>
                <div *ngIf="ProductoSeleccionado.descTipoActivo == 'Tarjeta de Credito'  && ProductoSeleccionado.nomEntidad == 'BANCO DE LOS TRABAJADORES'">
                    <h3> {{ProductoSeleccionado.COD_TIPO_TARJETA}}</h3>
                    <h2>Tipo de Tarjeta</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="producto" *ngIf="(ProductoSeleccionado.descTipoActivo == 'Prestamos' || ProductoSeleccionado.descTipoActivo == 'Factoraje') && ProductoSeleccionado.nomEntidad == 'BANCO DE LOS TRABAJADORES'">
        <div class="row">
            <div class="col-md-6">
                <h3>{{ProductoSeleccionado.descripcionTipoCredito}}</h3>
                <h2>Descripcion Tipo Credito</h2>
            </div>
            <div class="col-md-6">
                <h3>{{ProductoSeleccionado.MONTO_PAGADO_PRINCIPAL | currency:"Q "}}</h3>
                <h2>Monto Pagado Principal</h2>
            </div>
        </div>
    </div>
    <div class="producto" *ngIf="ProductoSeleccionado.descTipoActivo == 'Tarjeta de Credito'  && ProductoSeleccionado.nomEntidad == 'BANCO DE LOS TRABAJADORES'">
        <div class="row">
            <div class="col-md-6">
                <h3>{{ProductoSeleccionado.EXTRAFINANCIAMIENTO | currency:"Q "}}</h3>
                <h2>Extra Financiamiento</h2>
            </div>
            <div class="col-md-6">
            </div>
        </div>
    </div>
    <div class="producto" *ngIf="ProductoSeleccionado.descTipoActivo == 'Tarjeta de Credito'  && ProductoSeleccionado.nomEntidad == 'BANCO DE LOS TRABAJADORES'">
        <div class="row">
            <div class="col-md-12">
                <h3>{{ProductoSeleccionado.TIPO_TARJETA}}</h3>
                <h2>Tipo de Tarjeta</h2>
            </div>
        </div>
    </div>
    <div class="producto" *ngIf="ProductoSeleccionado.descTipoActivo == 'Prestamos' || ProductoSeleccionado.descTipoActivo == 'Factoraje'">
        <div class="row">
            <div class="col-md-6">
                <h2 style="font-size: 16px; margin-top:10px;">Directo</h2>
                <div style="background: #00aeb3; height: 3px; width: 45px;"
                            *ngIf="ProductoSeleccionado.DIRECTO_INDIRECTO=='DIRECTO'"> </div>
            </div>
            <div class="col-md-6">
                <h2 style="font-size: 16px; margin-top:10px;">Indirecto</h2>
                <div style="background: #00aeb3; height: 3px; width: 45px;"
                            *ngIf="ProductoSeleccionado.DIRECTO_INDIRECTO == 'INDIRECTO'"></div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div style="text-align: left;">
                <button class="btn round-button-back" (click)="goBack()">Regresar</button>
            </div>
        </div>
        <div class="col-md-6">

        </div>
    </div>
</div>
